import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { paths } from 'routes/paths';
import { CREATE_CLASSNAME_PREFIX as APPLICATION_CREATE_CLASSNAME_PREFIX } from 'screens/Applications&WorkOrders/Applications/Components/Notification';
import { CREATE_CLASSNAME_PREFIX as WORK_ORDER_CREATE_CLASSNAME_PREFIX } from 'screens/Applications&WorkOrders/WorkOrders/Components/Notification';
import { CREATE_CLASSNAME_PREFIX as PLAN_CREATE_CLASSNAME_PREFIX } from 'screens/Plans/redesign/components/Notification';
import { CREATE_CLASSNAME_PREFIX as INVOICE_CREATE_CLASSNAME_PREFIX } from 'screens/Invoices/redesign/components/Notification';
import { closeNotification } from 'components/Notification/genericNotification';
import { normalizePathname } from 'utilities/normalizePathname';

export type NotificationNavigationDestroyRule = {
  classNamePrefix: string;
  pathname: string;
};

const NOTIFICATIONS: NotificationNavigationDestroyRule[] = [
  {
    classNamePrefix: APPLICATION_CREATE_CLASSNAME_PREFIX,
    pathname: paths.applications
  },
  {
    classNamePrefix: WORK_ORDER_CREATE_CLASSNAME_PREFIX,
    pathname: paths.workOrders
  },
  {
    classNamePrefix: PLAN_CREATE_CLASSNAME_PREFIX,
    pathname: paths.plans
  },
  {
    classNamePrefix: INVOICE_CREATE_CLASSNAME_PREFIX,
    pathname: paths.invoices
  }
];

export { normalizePathname };

const useDestroyNotificationOnNavigation = () => {
  const location = useLocation();
  const currentPath = normalizePathname(location.pathname);

  useLayoutEffect(() => {
    NOTIFICATIONS.forEach(notification => {
      if (currentPath !== normalizePathname(notification.pathname)) {
        closeNotification(notification.classNamePrefix);
      }
    });
  }, [currentPath]);
};

export default useDestroyNotificationOnNavigation;
